import * as React from 'react';



export default class Contact extends React.Component {

    render() {

        return (
            <div className="formWrapper">
                <div className="header_openHours">
                    <div className="header_openHours_text">Kontakt</div>
                    <div className="header_openHours_body">Kontaktieren Sie uns gerne mit Ihrem Anliegen</div>
                </div>

                <form action="https://formsubmit.co/28397841aae1af65cddf993202c4030d " method="POST">
                    <div className="form-group">
                        <label className="form-label">
                            Name
                        </label>
                        <input
                            className="form-control"
                            name="name"
                            type="text"
                            placeholder="Namen eingeben"
                        />
                    </div>
                    <div className="form-group">
                        <label className="form-label">
                            Mail oder Mobil
                        </label>
                        <input
                            className="form-control"
                            name="email"
                            type="text"
                            placeholder="Mailadresse oder Telefonnummer eingeben"
                        />
                    </div>
                    <div className="form-group">
                        <label className="form-label">Nachricht</label>
                        <textarea
                            className="form-control"
                            name="message"
                            rows={10}
                            placeholder="Beschreiben Sie hier Ihr Anliegen!"
                        />
                    </div>
                    <button
                        className="btn-primary button_send"
                        type="submit"
                    >
                        senden
                    </button>
                </form>

                <div className="header_openHours">
                    <div className="header_openHours_text">Anfahrt</div>
                    <div className="header_openHours_body">Besuchen Sie uns gerne auch vor Ort</div>
                </div>
                <div style={{ height: '60vh', width: '100%' }}>
                    <iframe
                        width="100%"
                        height="100%"
                        src="https://www.google.com/maps/embed/v1/place?key=AIzaSyA2IgHgJgtE190DVzuwWJk0w-25SHRJL-Y
    &q=Mehele+Landtechnik,Hohenems+Austria"></iframe>
                </div>
            </div>
        );
    }

};


